import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import AttendanceService from '../../services/AttendanceService';
const initialState = {
    data: {},
    columnConfig: [],
    status: 'idle',
    formData: {
        // liability: [],
        // assets: [],
        // paymentTerm: [],
        // sequenceFormats: []
    }
};
export const fetchAttendance = createAsyncThunk('attendance', async () => {
    const response = await AttendanceService.getAttendanceByPage();
    return response;
});
export const AttendanceSlice = createSlice({
    name: 'attendance',
    initialState,
    reducers: {
        addAttendanceColumnConfig: (state, action) => {
            const configs = action.payload;
            let configsToStore = [];
            configs.forEach((config) => {
                configsToStore.push({
                    ...config,
                    key: config.columnCode,
                    options: config.options ? config.options : []
                });
            });
            state.columnConfig = configsToStore;
        },
        addColumnToAttendanceColumnConfig: (state, action) => {
            state.columnConfig = [...state.columnConfig, action.payload];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAttendance.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAttendance.fulfilled, (state, action) => {
                state.status = 'idle';
                state.data = action.payload;
            })
    }
});

export const { addAttendanceColumnConfig, addColumnToAttendanceColumnConfig } =
    AttendanceSlice.actions;

export const selectAttendance = (state) => {

    return state.attendance.data
};

export const selectAttendanceColumnConfig = (state) =>
    state.attendance.columnConfig;

export default AttendanceSlice.reducer;